import React, { Fragment } from "react";

function Footer() {
  return (
    <div className="text-center bg-dark text-white py-2 fixed-bottom">
      <span>
        Copyright & Developed by{" "}
        <a href="https://www.linkedin.com/in/imbharathkumarp/" target="blank">
          FATAFAT
        </a>
      </span>
    </div>
  );
}

export default Footer;
